import { FormArray, FormGroup } from '@angular/forms';

import { FormType } from './types';
import { createDatasourceForm, createMappingForm, createUIForm } from './components';

export const createForm = (index: number) => {
  return new FormGroup<FormType>({
    ui: createUIForm(index),
    mapping: createMappingForm(),
    datasource: createDatasourceForm(),
    params: new FormArray<FormGroup>([]),
  });
};
